import { Injectable } from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {classToPlain, plainToClass} from 'class-transformer';
import {db} from "../../dexie/db";

import { SOPutAttributeSpec } from './so-put-attribute-spec';
import { SOGetAttributeSpec } from './so-get-attribute-spec';
import { SOPostAttributeSpec } from './so-post-attribute-spec';
import { SODeleteAttributeSpec } from './so-delete-attribute-spec';
import {SORespAttributeSpec} from './so-resp-attribute-spec';
import {SOPluralAttributeSpec} from './so-plural-attribute-spec';

import {MMEntityService} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {MMEntityServiceBase} from 'lionheartland';
import {HttpHeaders} from "@angular/common/http";

export class EOAttributeSpecService extends MMEntityServiceBase implements MMEntityService {

  constructor(
    public entityCore: EntityCoreProtocol,
  ) {
    super('attribute_spec', entityCore);
  }

  /** GET AttributeSpec by id. Will 404 if id not found */
  get(request: SOGetAttributeSpec): Observable<SOPluralAttributeSpec> {
    return this.httpClient.get<SOPluralAttributeSpec>(this.makeGetUri(request), this.httpOptions).pipe(
      map(resp => plainToClass(SOPluralAttributeSpec, resp)),
      tap(async (response: SOPluralAttributeSpec) => {
        this.log(`fetched AttributeSpec`);
        // After a successful server response, update IndexedDB
        const activities = response.toAttributeSpecs(); // Convert your response to an array of AttributeSpec instances
        const promises = activities.map(attributeSpec => db.attributeSpecs.put(attributeSpec));
        await Promise.all(promises); // Wait for all the IndexedDB update operations to complete
      }),
      catchError(this.handleError<SOPluralAttributeSpec>(`get AttributeSpec`))
    );
  }

    /** GETCACHE for initial display with CacheQueryProtocol */
    getCache(cacheQuery: any): Observable<SOPluralAttributeSpec> {
        console.log("GETCACHE", cacheQuery);

        if (cacheQuery.filterKey === 'attributeSpec' && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on parent and organization")
            return from(db.attributeSpecs.where('parentUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }
        else if (cacheQuery.filterKey + "s" == "interphace" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('interphaceUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "simpleAttribute" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('simpleAttributeUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "relationshipAttribute" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('relationshipAttributeUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "realizations" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('realizationsUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "project" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('projectUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "organization" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.attributeSpecs.where('organizationUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterOrganization || cacheQuery.organization.uid)
        {
            console.log("tripped organization for cache query")
            if ( cacheQuery?.filterOrganization != null )
            {
                console.log("cache filtering based on organization CQP", cacheQuery)
                return from(db.attributeSpecs.where('organizationUid').equals(cacheQuery.filterOrganization).toArray()).pipe(
                    map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else if ( cacheQuery?.organization?.uid != null )
            {
                console.log("UID:", cacheQuery.organization.uid)
                console.log("cache filtering based on organization SOGet")
                return from(db.attributeSpecs.where('organizationUid').equals(cacheQuery.organization.uid).toArray()).pipe(
                    map(attributeSpecsArray => this.processAttributeSpecs(attributeSpecsArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else
            {
                console.log("null organization")
            }
        }
        else
        {
            console.log("cache no filter")
            return from(db.attributeSpecs.toArray()).pipe(
                map((attributeSpecsArray) => {
                    // Convert the array of plain objects to an array of SORespAttributeSpec instances
                    const sorAttributeSpecs = attributeSpecsArray.map(req => plainToClass(SORespAttributeSpec, req));
                    // Create and return a new instance of SOPluralAttributeSpec
                    const pluralAttributeSpec = new SOPluralAttributeSpec();
                    pluralAttributeSpec.objects = sorAttributeSpecs;
                    pluralAttributeSpec.nextOffset = null; // Assuming there is no pagination in cache
                    return pluralAttributeSpec;
                }),
                catchError(error => this.handleQueryError(error))
            );
        }
    }

    private processAttributeSpecs(attributeSpecsArray) {
        const sorAttributeSpecs = attributeSpecsArray.map(req => plainToClass(SORespAttributeSpec, req));
        const pluralAttributeSpec = new SOPluralAttributeSpec();
        pluralAttributeSpec.objects = sorAttributeSpecs;
        pluralAttributeSpec.nextOffset = null;
        return pluralAttributeSpec;
    }

    private handleQueryError(error) {
        console.error('Error in query:', error);
        return throwError(error); // Return an observable error
    }

post(request: SOPostAttributeSpec): Observable<SORespAttributeSpec> {
  return this.httpClient.post<SORespAttributeSpec>(this.coreUrl + this.route, request, this.httpOptions).pipe(
    map(resp => plainToClass(SORespAttributeSpec, resp)),

    tap(async (response: SORespAttributeSpec) => {
      this.log(`added AttributeSpec w/ id=${response.uid}`);
      // After a successful server response, update IndexedDB
      console.log("here", response);
      console.log("here request", request);
      await db.attributeSpecs.add(response.toAttributeSpec());
    }),
    catchError(this.handleError<SORespAttributeSpec>('AttributeSpec post'))
  );
}


  put(request: SOPutAttributeSpec): Observable<SORespAttributeSpec> {
    const uid = request.uid;
    const uri = `${this.coreUrl}${this.route}/${uid}`;
    return this.httpClient.put<SORespAttributeSpec>(uri, request, this.httpOptions).pipe(
      map(resp => plainToClass(SORespAttributeSpec, resp)),
      tap(async (response: SORespAttributeSpec) => {
        this.log(`edited AttributeSpec w/ uid=${uid}`);
        // After a successful server response, update IndexedDB
        await db.attributeSpecs.put(response.toAttributeSpec());
      }),
      catchError(this.handleError<SORespAttributeSpec>('AttributeSpec put'))
    );
  }


  delete(request: SODeleteAttributeSpec): Observable<SORespAttributeSpec> {
    return this.httpClient.delete<SORespAttributeSpec>(this.makeDeleteUri(request), this.httpOptions).pipe(
      tap(async _ => {
        this.log(`deleted AttributeSpec uid=${request.uid}`);
        // After a successful server response, update IndexedDB
        await db.attributeSpecs.delete(request.uid);
      }),
      catchError(this.handleError<SORespAttributeSpec>('AttributeSpec delete'))
    );
  }


}
